// import 'flickity/dist/flickity.pkgd.js';
// import Flickity from 'flickity';

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    // upComingToursSlider();
  },
};

// $(window).on('resize', function () {
//   $('.home-upcoming-tours-section.slider .upcoming-tours-wrp').flickity('resize');
// });

// $(window).on('load', function () {
//   $('.home-upcoming-tours-section.slider .upcoming-tours-wrp').flickity('resize');
// });

// function upComingToursSlider() {
//   var cellAlignValue = '';

//   if (matchMedia('screen and (max-width: 767px)').matches) {
//     cellAlignValue = 'center';
//   } else {
//     cellAlignValue = 'left';
//   }

//   $('.home-upcoming-tours-section.slider .upcoming-tours-wrp').flickity({
//     pageDots: false,
//     prevNextButtons: false,
//     wrapAround: true,
//     adaptiveHeight: true,
//     autoPlay: true,
//     cellAlign: cellAlignValue,
//   });

//   // $('.home-upcoming-tours-section').each(function () {
//   //   $(this).find('.flickity-button').appendTo($(this).find('.flickity-button-wrp'));
//   // });
// }
